module.exports = "/_next/static/images/photoEdgarDacin-702aaafef26a81f13c4dfb280ba75abd.webp";